import { render, staticRenderFns } from "./CreateEstilo.vue?vue&type=template&id=d8fae78c&"
import script from "./CreateEstilo.vue?vue&type=script&lang=js&"
export * from "./CreateEstilo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports